import { z } from "zod";

/** Competência é sempre "AAAA-MM" na API; no banco, o 1º dia do mês (coluna DATE, em UTC). */
export const competenciaSchema = z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/, "Mês inválido");
/** Data sem hora ("AAAA-MM-DD"), como vencimento e pagamento. */
export const dataSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Data inválida");

export function competenciaParaData(competencia: string): Date {
  const [a, m] = competencia.split("-").map(Number);
  return new Date(Date.UTC(a!, m! - 1, 1));
}

export function dataParaCompetencia(d: Date): string {
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}`;
}

export function textoParaData(texto: string): Date {
  const [a, m, d] = texto.split("-").map(Number);
  return new Date(Date.UTC(a!, m! - 1, d!));
}

export function dataParaTexto(d: Date): string {
  return d.toISOString().slice(0, 10);
}

export function somarMeses(competencia: string, n: number): string {
  const d = competenciaParaData(competencia);
  return dataParaCompetencia(new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + n, 1)));
}

/** Intervalo [início, fim) do mês, para filtrar colunas com hora (ex: concludedAt). */
export function intervaloDoMes(competencia: string): { inicio: Date; fim: Date } {
  return { inicio: competenciaParaData(competencia), fim: competenciaParaData(somarMeses(competencia, 1)) };
}

const BRASILIA_MS = 3 * 60 * 60 * 1000;

/** Competência de hoje no fuso de Brasília. */
export function competenciaAtual(agora = new Date()): string {
  return dataParaCompetencia(new Date(agora.getTime() - BRASILIA_MS));
}

/** "AAAA-MM-DD" de hoje no fuso de Brasília. */
export function hojeEmTexto(agora = new Date()): string {
  return dataParaTexto(new Date(agora.getTime() - BRASILIA_MS));
}

const MESES = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];

export function nomeDoMes(competencia: string): string {
  const [a, m] = competencia.split("-").map(Number);
  return `${MESES[m! - 1]} de ${a}`;
}

/** Intervalo do mês no relógio de Brasília, para colunas com hora (concluído em, resolvido em). */
export function intervaloDoMesEmBrasilia(competencia: string): { inicio: Date; fim: Date } {
  const { inicio, fim } = intervaloDoMes(competencia);
  return { inicio: new Date(inicio.getTime() + BRASILIA_MS), fim: new Date(fim.getTime() + BRASILIA_MS) };
}
